import Storage from '../lib/storage';

const baseConfig = {
  authEndpoint: 'http://44.238.165.59:4000',
  serviceEndpoint: 'http://attribute-labeling-prod.adeptmind.ai:1738',
  configurationId: '',
  shopId: '',
};

class ConfigsManager {
  baseConfigs: any;
  
  constructor() {
    const cachedConfigs = Storage.getStorage('attribute-extraction-tool-configs');

    try {
      this.baseConfigs = {
        ...baseConfig,
        ...cachedConfigs
      };
    } catch (error) {
      Storage.removeStorage('attribute-extraction-tool-configs');

      this.baseConfigs = {
        ...baseConfig
      };
    }
  }

  get configs() {
    return this.baseConfigs;
  }

  setConfigs(newConfigs = {}) {
    this.baseConfigs = {
      ...this.baseConfigs,
      ...newConfigs
    };

    Storage.setStorage('attribute-extraction-tool-configs', JSON.stringify(this.baseConfigs));
  }
}

export const configsManager = new ConfigsManager(); 
